import { z } from 'zod/v4';
// Office status
export const OfficeStatusSchema = z.enum([
    'active',
    'inactive',
    'closed',
]);
// Office type
export const OfficeTypeSchema = z.enum([
    'headquarters',
    'regional',
    'satellite',
    'virtual',
]);
// Office schema - company office locations
export const OfficeSchema = z.object({
    id: z.string().uuid(),
    code: z.string(), // Short code (e.g., "LA-HQ", "SF-01")
    name: z.string(),
    officeType: OfficeTypeSchema,
    // Address
    address: z.object({
        street1: z.string(),
        street2: z.string().optional(),
        city: z.string(),
        state: z.string(),
        zip: z.string(),
        country: z.string().default('US'),
    }),
    // Contact information
    phone: z.string().optional(),
    fax: z.string().optional(),
    email: z.string().email().optional(),
    // Hours of operation
    hoursOfOperation: z.object({
        monday: z.object({ open: z.string(), close: z.string() }).optional(),
        tuesday: z.object({ open: z.string(), close: z.string() }).optional(),
        wednesday: z.object({ open: z.string(), close: z.string() }).optional(),
        thursday: z.object({ open: z.string(), close: z.string() }).optional(),
        friday: z.object({ open: z.string(), close: z.string() }).optional(),
        saturday: z.object({ open: z.string(), close: z.string() }).optional(),
        sunday: z.object({ open: z.string(), close: z.string() }).optional(),
    }).optional(),
    timezone: z.string().default('America/Los_Angeles'),
    // Manager
    managerId: z.string().uuid().optional(),
    managerName: z.string().optional(), // Denormalized
    // Notes
    notes: z.string().optional(),
    // Status
    status: OfficeStatusSchema.default('active'),
    // Timestamps
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateOfficeSchema = OfficeSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateOfficeSchema = OfficeSchema.partial().omit({
    id: true,
    createdAt: true,
});
// Office preview
export const OfficePreviewSchema = z.object({
    id: z.string().uuid(),
    code: z.string(),
    name: z.string(),
    officeType: OfficeTypeSchema,
    city: z.string(),
    state: z.string(),
    phone: z.string().optional(),
    status: OfficeStatusSchema,
    staffCount: z.number().optional(),
});
